import * as React from "react";
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import "./../../resources/forest.jpg";

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import Chip from '@material-ui/core/Chip';
import AlarmIcon from '@material-ui/icons/Alarm';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';


import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import { ExerciseTask, TaskOption, Exercise, Execution } from '../server/ExamServer'
import ExamTask from "./ExamTask";
import AdminExecutionItem from "./AdminExecutionItem";
import CircularProgress from '@material-ui/core/CircularProgress';

import ExamServer from '../server/ExamServer'


const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});



export interface AdminExecutionListProps {

    // onFinished:() => void
    // onTimeExceeded:() => void
}

export interface AdminExecutionListState {
    exams: Array<Execution>|undefined
}


class AdminExecutionList extends React.Component<AdminExecutionListProps, AdminExecutionListState> {


    server: ExamServer;
    constructor(props: AdminExecutionListProps) {
        super(props);
        this.state = {
            exams:undefined
        };

        this.server = new ExamServer()
        this.server.getExams().then(exams => {
            this.setState({ 
                exams
            })
        })


    }


    render() {

        return (
            <React.Fragment>

                <Typography variant="h4" align="left" color="textPrimary" component="h5" gutterBottom style={{marginTop:theme.spacing(3)}}>
                    Exam Results {this.state.exams?(<Chip label={this.state.exams.length} />):null}
                </Typography>
                <Typography variant="body1" align="left" color="textPrimary" component="h5" gutterBottom>
                    All exams will be listed here. You could view the results.
                </Typography>

                {this.state.exams ? (
                    <React.Fragment>


                        {this.state.exams.sort((a, b) => {return b.time- a.time}).map(exam =>{
                            return ( <AdminExecutionItem exam={exam} />)

                        })}

                    </React.Fragment>
                ) : (
                    <Grid container
                        justify="center"
                        alignItems="center"
                        style={{
                            height: "calc(100vh - 300px)"
                        }}
                    >
                        <Grid item md={12} lg={6} xl={6} style={{ textAlign: "center" }}>
                            <CircularProgress color="secondary" />
                        </Grid>
                    </Grid>
                    )}

            </React.Fragment>

        );
    }
}

export default AdminExecutionList;
